import { ActionIcon, ColorSwatch, Divider, Kbd, Popover } from '@mantine/core';
import { Info } from 'lucide-react';
import { FC } from 'react';

import Heading2 from '@/components/text/Heading2.tsx';

import Paragraph from '../text/Paragraph.tsx';

const CalendarLegend: FC = () => {
    return (
        <Popover
            classNames={{
                dropdown: 'w-[400px] shadow-lg',
            }}
            position="right-end"
            offset={{ mainAxis: 12, crossAxis: -35 }}
            withArrow
        >
            <Popover.Target>
                <ActionIcon variant="subtle" size="xl">
                    <Info className="size-8 text-blue-600" />
                </ActionIcon>
            </Popover.Target>

            <Popover.Dropdown>
                <div className="flex flex-col gap-4">
                    <Heading2 className="font-bold">Farben</Heading2>
                    <div className="flex items-center gap-2">
                        <ColorSwatch color="#E2E3E6" />
                        <Paragraph className="text-sm">Sperrzeiten - Arzt nicht verfügbar</Paragraph>
                    </div>
                    <div className="flex items-center gap-2">
                        <div className="size-7 rounded-full border border-gray-300 bg-striped-gray" />
                        <Paragraph className="text-sm">Fehlerhafter Termin</Paragraph>
                    </div>
                    <Divider />
                    <div className="flex flex-col gap-2">
                        <Heading2 className="font-bold">Tastatur Navigation:</Heading2>
                        <div className="mt-2 flex items-center gap-2">
                            <Kbd size="md" className="px-1">
                                ←
                            </Kbd>
                            <Kbd size="md" className="px-1">
                                →
                            </Kbd>
                            <Paragraph className="text-sm">horizontal scrollen</Paragraph>
                        </div>
                        <div className="flex items-center gap-2">
                            <Kbd size="md" className="px-1">
                                ↑
                            </Kbd>
                            <Kbd size="md" className="px-1">
                                ↓
                            </Kbd>
                            <Paragraph className="text-sm">vertikal scrollen</Paragraph>
                        </div>
                    </div>
                </div>
            </Popover.Dropdown>
        </Popover>
    );
};

export default CalendarLegend;
